import { PropsWithChildren, useContext } from 'react';
import { PlaybackStoreContext } from './playback.context';

/**
 * Renders children only when a playback store is available in context.
 * Used when nested inside another playback provider to avoid rendering until
 * the parent has registered this instance's store (prevents flash of wrong store).
 */
export function PlaybackGuard({ children }: PropsWithChildren) {
  const ctx = useContext(PlaybackStoreContext);
  return ctx?.store ? children : null;
}
